// extracted by mini-css-extract-plugin
export default {"fullWidth":"Ah-z","hasStyledAspectRatio":"Bh-z"};